module.exports = __webpack_public_path__ + "img/urgent-icon.svg";